// 导出所有组件
export { default as VtkStepper } from './components/assembly/VtkStepper.vue'
export { default as VtkMessage } from './components/message/vtkMessage.vue'
export { default as VtkArea } from './components/assembly/VtkArea.vue'
export { default as VtkCount } from './components/assembly/VtkCount.vue'
export { default as VtkDatePicker } from './components/assembly/VtkDatePicker.vue'
export { default as VtkEmpty } from './components/assembly/VtkEmpty.vue'
export { default as VtkFab } from './components/assembly/VtkFab.vue'
export { default as VtkFormItem } from './components/assembly/VtkFormItem.vue'
export { default as VtkImg } from './components/assembly/VtkImg.vue'
export { default as VtkPage } from './components/assembly/VtkPage.vue'
export { default as VtkPdf } from './components/assembly/VtkPdf.vue'
export { default as VtkProj } from './components/assembly/VtkProj.vue'
export { default as VtkSearch } from './components/assembly/VtkSearch.vue'

// 导出工具类
export { default as storage } from './commons/storage'
export { default as request } from './commons/request'
export { default as message } from './components/message/index.js'

// 导出 composables - 使用具名导出
export { useFilters } from './composables/useFilters'
export { useDirectives } from './composables/useDirectives'
export { useMixins } from './composables/useMixins'
export { default as usePagination } from './composables/usePagination'

// 导出插件
export { default as filters } from './plugins/filters'
export { default as directives } from './plugins/directives'

// 导入全局对象
import vtk from './commons/index'

// 默认导出安装函数
export default {
  install(app) {
    // 注册全局属性
    app.config.globalProperties.$vtk = vtk
  }
}
